function removeUnderscores(string) {
  return string.replace(/_/g, " ");
}

module.exports = removeUnderscores;
